package com.wintermar.inspection.core.ui.theme.color.palette.accent

import androidx.compose.ui.graphics.Color
import com.wintermar.inspection.core.ui.theme.color.model.ColorVariant

val RedColorVariant = ColorVariant(
    n100 = Color(0xFFFFECEB),
    n200 = Color(0xFFFFD5D2),
    n300 = Color(0xFFFD9891),
    n400 = Color(0xFFF87168),
    n500 = Color(0xFFF15B50),
    n600 = Color(0xFFE2483D),
    n700 = Color(0xFFC9372C),
    n800 = Color(0xFFAE2E24),
    n900 = Color(0xFF5D1F1A),
    n1000 = Color(0xFF42221F)
)
